import { Directive, Input } from '@angular/core';
import { Validator, AbstractControl, ValidationErrors, ValidatorFn, FormControl, NG_VALIDATORS } from '@angular/forms';

@Directive({
  selector: '[hexvalidator]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: HexValidatorDirective,
      multi: true
    }
  ]
})
export class HexValidatorDirective implements Validator {
  @Input("hexvalidator") appHexValidator;

  constructor() {
  }

  validate(control: AbstractControl): ValidationErrors {
    let value = (<FormControl>control).value;
    if (value) {
      if (value.match(/^[a-f0-9]*$/i)) {
        return null;
      } else {
        return {
          hexvalidator: {
            valid: false
          }
        };
      }
    }
    return null;
  }
}
